export default __webpack_public_path__ + "static/media/notes4.5c2ab772.png";